import React, { FC } from 'react';
import { MoreMenu as MoreMenuCore, MenuItem } from 'ia-react-core';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { StyledMoreMenu, StyledP } from './MoreMenu.styles';
import { setIsDeleting } from '../../../../../../../../actions/Notifications.actions';

export interface MoreMenuProps {
  id: string;
}

const MoreMenu: FC<MoreMenuProps> = ({ id }) => {
  const { t } = useTranslation('Notifications');
  const dispatch = useDispatch();

  return (
    <StyledMoreMenu>
      <MoreMenuCore
        items={[
          <MenuItem
            onClick={() => dispatch(setIsDeleting(id, true))}
          >
            <StyledP>{t('delete')}</StyledP>
          </MenuItem>,
        ]}
      />
    </StyledMoreMenu>
  );
};
export default MoreMenu;
